import React, { useRef, useState } from 'react';
import { motion, useAnimationFrame, useMotionValue, useReducedMotion } from 'framer-motion';
import { QuoteIcon } from 'lucide-react';
import { chatTestimonials } from '../data/testimonials';
import { ChatTestimonial } from '../types/content';
const SPEED = 48; // px per second

function ChatCard({
  testimonial
}: {
  testimonial: ChatTestimonial;
}) {
  return <figure className="w-[248px] shrink-0 sm:w-[280px]" data-id="element-119" data-mp="10uira6e2ekh5">
      <img src={testimonial.image} alt={`Conversación de WhatsApp con ${testimonial.name}`} loading="lazy" className="w-full rounded-2xl border border-gold/25 bg-ink-soft object-cover" data-id="element-120" data-mp="10sxvyejxexi8" />
      <figcaption className="mt-4 flex gap-3" data-id="element-121" data-mp="15lhapeucnyom">
        <QuoteIcon className="h-4 w-4 shrink-0 text-gold" aria-hidden="true" data-id="element-122" data-mp="15msg1j3g1ehu" />
        <p className="text-sm leading-relaxed text-white/70" data-id="element-123" data-mp="1khyo0bm3nndt">
          “{testimonial.quote}”
          <span className="mt-1 block font-semibold text-gold-soft" data-id="element-124" data-mp="1fk6td9u2ln5x">
            — {testimonial.name}
          </span>
        </p>
      </figcaption>
    </figure>;
}
export function TestimonialsCarousel() {
  const trackRef = useRef<HTMLDivElement>(null);
  const x = useMotionValue(0);
  const [paused, setPaused] = useState(false);
  const reduceMotion = useReducedMotion();
  useAnimationFrame((_, delta) => {
    if (paused || reduceMotion || !trackRef.current) return;
    const half = trackRef.current.scrollWidth / 2;
    if (half <= 0) return;
    let next = x.get() - SPEED * delta / 1000;
    if (next <= -half) next += half;
    x.set(next);
  });
  const items = [...chatTestimonials, ...chatTestimonials];
  return <section className="bg-ink-soft py-16 lg:py-24" id="testimonios" aria-labelledby="testimonios-title" data-id="element-125" data-mp="3b0wuoigy0ab7">
      <div className="mx-auto max-w-5xl px-5 lg:px-8" data-id="element-126" data-mp="3f3bd51gp981y">
        <h2 id="testimonios-title" className="font-display text-3xl leading-tight text-gold-soft sm:text-4xl" data-id="element-127" data-mp="3k1cy5rxorhg2">
          Ellos recuperaron su amor…
          <span className="block text-white" data-id="element-128" data-mp="1owlxvwwldy66">solo faltas tú.</span>
        </h2>
        <p className="mt-4 max-w-2xl text-lg text-white/70" data-id="element-129" data-mp="1jy2b5ua6cicr">
          Mensajes reales de personas que confiaron y hoy están de nuevo con
          quien aman.
        </p>
      </div>

      <div className="marquee-mask mt-12 overflow-hidden" onMouseEnter={() => setPaused(true)} onMouseLeave={() => setPaused(false)} onFocus={() => setPaused(true)} onBlur={() => setPaused(false)} data-id="element-130" data-mp="1yp1h0xjmkssn">
        <motion.div ref={trackRef} style={{
        x
      }} className="flex w-max gap-6 px-5 lg:px-8" data-id="element-131" data-mp="23mt7dn4mg6uq">
          {items.map((testimonial, index) => <ChatCard key={`${testimonial.id}-${index}`} testimonial={testimonial} data-id="element-132" data-mp="2cmzhr050wqpo" data-mpi={index} />)}
        </motion.div>
      </div>
    </section>;
}